export default function DataDeletion() {
  return (
    <div className="bg-white" data-testid="data-deletion-page">
      <div className="max-w-3xl mx-auto px-6 py-14">
        <h1 className="text-3xl font-bold text-[#3C4048] mb-2" style={{ fontFamily: "Montserrat", fontWeight: 800 }}>
          Data Deletion Instructions
        </h1>
        <p className="text-[#7A9090] text-sm mb-10">Last updated: 27 August 2026</p>

        <div className="space-y-6 text-[#3C4048] text-sm leading-relaxed [&_h2]:text-lg [&_h2]:font-bold [&_h2]:mb-3 [&_h2]:mt-0 [&_p]:mb-3 [&_ul]:list-disc [&_ul]:pl-5 [&_ul]:space-y-1 [&_a]:text-[#3A7A8C] [&_a]:font-semibold [&_a]:underline" style={{ fontFamily: "Montserrat" }}>
          <section>
            <h2>How to disconnect Facebook/Instagram and delete related data</h2>
            <p>
              If you've connected a Facebook Page or Instagram account to Post Your Content ("PYC"), you can
              remove that connection and the data it created at any time:
            </p>
            <ul>
              <li>
                In PYC, go to <strong>Settings</strong> and click <strong>Disconnect</strong> on the
                Facebook/Instagram card. This immediately deletes the stored connection (access tokens, Page
                and Instagram account references) for your workspace.
              </li>
              <li>
                You can also remove PYC's access directly from Facebook: go to Facebook{" "}
                <strong>Settings &gt; Apps and Websites</strong>, find "Post Your Content," and remove it.
                This revokes our access on Meta's side immediately.
              </li>
              <li>
                To delete any content (posts, drafts, media) already stored in your PYC workspace, email{" "}
                <a href="mailto:hello@postyourcontent.com">hello@postyourcontent.com</a> from your account's
                email and we'll permanently delete your workspace's data within 30 days.
              </li>
            </ul>
          </section>

          <section>
            <h2>What gets deleted</h2>
            <p>
              Disconnecting removes the encrypted access tokens and the Page/Instagram account reference tied
              to your workspace. Content already published to Facebook/Instagram is not affected (you manage
              that directly on those platforms). A full workspace-deletion request also removes your saved
              posts, media, and brand profile from our database.
            </p>
          </section>

          <section>
            <h2>Contact</h2>
            <p>
              Questions about this process: <a href="mailto:hello@postyourcontent.com">hello@postyourcontent.com</a>
            </p>
          </section>
        </div>
      </div>
    </div>
  );
}
